import React from 'react';
import './style.scss';
import { Routes, Route } from 'react-router-dom';

import NavBar from '../../components/NavBar/Connection';

import AcceptedIndex from './Accepted/Index';
import PendingIndex from './Pending/Index';
import SendIndex from './Send/Index';
// import FourOFour from '../FourOFour/Index';

const Master = () => {
  return (
    <div className="connection-master">
        <div className='d-block d-lg-none'><NavBar /></div>

      <Routes>
        <Route path="/" element={<AcceptedIndex />} />
        <Route path="send" element={<SendIndex />} />
        <Route path="pending" element={<PendingIndex />} />

        {/* 404 */}
        {/* <Route path="*" element={<FourOFour />} /> */}
      </Routes>
    </div>
  );
};

export default Master;
